import { apiClient } from './client';

export interface AppNotification {
  id: number;
  tenantId: number;
  type: string;
  title: string;
  message: string;
  isRead: boolean;
  referenceId?: number;
  referenceType?: string;
  senderTenantName?: string;
  createdAt: string;
  // enriched client-side after fetch
  orderAmount?: number;
  itemsCount?: number;
  partyArea?: string;
  partyCity?: string;
  partyGstin?: string;
}

export interface Page<T> {
  content: T[];
  totalElements: number;
  totalPages: number;
  number: number;
  size: number;
}

export async function listNotifications(params?: {
  unreadOnly?: boolean;
  page?: number;
  size?: number;
}): Promise<Page<AppNotification>> {
  const resp = await apiClient.get('/notifications', { params });
  return resp.data;
}

export async function getUnreadCount(): Promise<number> {
  const resp = await apiClient.get<{ count: number }>('/notifications/count');
  return resp.data.count;
}

export async function markRead(id: number): Promise<void> {
  await apiClient.put(`/notifications/${id}/read`);
}

export async function markAllRead(): Promise<void> {
  await apiClient.put('/notifications/read-all');
}
